import { debounce } from "../../shared/js/debounce";
import { superToggle } from "./helpers/super-toggle";

window.addEventListener('load', () => {

    // Dropdown Test
    let offCanvasMenu = document.getElementById('offCanvasMenu');
    let menuToggleDropdown = document.getElementById('menuToggleDropdown');
    let desktopHeaderMenuCloseText = document.getElementById('desktopHeaderMenuCloseText')

    let offCanvasMenuMobile = document.getElementById('offCanvasMenuMobile');
    let menuToggleMobile = document.getElementById('menuToggleMobile');
    let mobileBurger = document.querySelector('#menuToggleMobile > .menu-burger');
    let mobileHbParts = mobileBurger.querySelectorAll('.hb-part');

    let burgerIcons = document.querySelectorAll('.menu-burger');
    let headerNavigationBackground = document.getElementById('headerNavigationBackground');

    let menuBackdrop = document.getElementById('headerNavigationBackdrop');

    let headerLogo = document.getElementById('rooftopHeaderLogo');
    let headerLogoSvg = document.getElementById('rooftopHeaderLogoSvg');

    let scrollLimit = 500;
    let menuDelayForFirstRun = 50;

    if (offCanvasMenu && menuToggleDropdown) {
        menuToggleDropdown.addEventListener('click', () => {
            // measures to stop menu appearing on page load
            offCanvasMenu.removeAttribute('style');

            const delayOnFirstRun = setTimeout(() => {
                if (headerLogo) {
                    superToggle(headerLogo, ['!opacity-100', '!pointer-events-auto', 'delay-300']);
                }

                offCanvasMenu.classList.toggle('-translate-y-full');
                menuToggleDropdown.classList.toggle('active');

                if (menuBackdrop) {
                    menuBackdrop.classList.toggle('opacity-0');
                }

                scrollLimit = (offCanvasMenu.offsetHeight / 3) * 2;
                toggleBurgers();
                startListening();

                menuDelayForFirstRun = 0;
            }, menuDelayForFirstRun);
        });

        if (desktopHeaderMenuCloseText) {
            desktopHeaderMenuCloseText.addEventListener('click', () => {
                closeAllNavs();
            });
        }
    }

    if (offCanvasMenuMobile && menuToggleMobile) {
        menuToggleMobile.addEventListener('click', () => {
            // measures to stop menu appearing on page load
            offCanvasMenuMobile.removeAttribute('style');

            const delayOnFirstRun = setTimeout(() => {
                if (headerLogo) {
                    superToggle(headerLogo, ['!opacity-100', '!pointer-events-auto']);
                }
                if (headerLogoSvg) {
                    superToggle(headerLogoSvg, ['!text-white']);
                }
                superToggle(menuToggleMobile, ['!bg-white']);
                for (let part of mobileHbParts) {
                    superToggle(part, ['!bg-rooftop-blue']);
                }

                headerNavigationBackground.classList.toggle('opacity-0');
                offCanvasMenuMobile.classList.toggle('-translate-y-full');
                menuToggleMobile.classList.toggle('active');

                if (menuBackdrop) {
                    menuBackdrop.classList.toggle('opacity-0');
                }

                scrollLimit = (offCanvasMenuMobile.offsetHeight / 3) * 2;
                toggleBurgers();
                startListening();
                menuDelayForFirstRun = 0;
            }, menuDelayForFirstRun);
        });
    }

    function toggleBurgers() {
        for (let burger of burgerIcons) {
            let hamburgerTop1 = burger.querySelector('.hamburger-top-1');
            let hamburgerTop2 = burger.querySelector('.hamburger-top-2');
            let hamburgerMid = burger.querySelector('.hamburger-mid');
            let hamburgerBot = burger.querySelector('.hamburger-bot');

            if (hamburgerTop1 && hamburgerTop2 && hamburgerMid && hamburgerBot ){
                superToggle(hamburgerTop1, ['!top-1/2', 'rotate-45']);
                superToggle(hamburgerTop2, ['!top-1/2', '-rotate-45']);
                superToggle(hamburgerMid, ['opacity-0', '!w-0']);
                superToggle(hamburgerBot, ['opacity-0', '!w-0', '!-translate-y-2']);
            }
        }
    }

    function closeBurgers() {
        for ( let burger of burgerIcons ) {
            let hamburgerTop1 = burger.querySelector('.hamburger-top-1');
            let hamburgerTop2 = burger.querySelector('.hamburger-top-2');
            let hamburgerMid = burger.querySelector('.hamburger-mid');
            let hamburgerBot = burger.querySelector('.hamburger-bot');

            if (hamburgerTop1 && hamburgerTop2 && hamburgerMid && hamburgerBot) {
                hamburgerTop1.classList.remove('!top-1/2');
                hamburgerTop1.classList.remove('rotate-45');
                hamburgerTop2.classList.remove('!top-1/2');
                hamburgerTop2.classList.remove('-rotate-45');
                hamburgerMid.classList.remove('opacity-0');
                hamburgerMid.classList.remove('!w-0');
                hamburgerBot.classList.remove('opacity-0');
                hamburgerBot.classList.remove('!w-0');
                hamburgerBot.classList.remove('!-translate-y-2');
            }
        }
    }

    function closeMobileNav() {
        headerNavigationBackground.classList.remove('opacity-0');

        if (!offCanvasMenuMobile.classList.contains('-translate-y-full')) {
            offCanvasMenuMobile.classList.add('-translate-y-full');

        }
        if (!menuBackdrop.classList.contains('opacity-0')) {
            menuBackdrop.classList.add('opacity-0');
        }

        if (headerLogo) {
            headerLogo.classList.remove('!opacity-100', '!pointer-events-auto', 'delay-300');
        }

        if (headerLogoSvg) {
            headerLogoSvg.classList.remove('!text-white');
        }
        menuToggleMobile.classList.remove('!bg-white');
        for (let part of mobileHbParts) {
            part.classList.remove('!bg-rooftop-blue');
        }
    }

    function closeDesktopNav() {
        headerNavigationBackground.classList.remove('opacity-0');

        if (!offCanvasMenu.classList.contains('-translate-y-full')) {
            offCanvasMenu.classList.add('-translate-y-full');
            menuToggleDropdown.classList.remove('active');
        }
        if (!menuBackdrop.classList.contains('opacity-0')) {
            menuBackdrop.classList.add('opacity-0');
        }
        if (headerLogo) {
            headerLogo.classList.remove('!opacity-100', '!pointer-events-auto', 'delay-300');
        }

        if (headerLogoSvg) {
            headerLogoSvg.classList.remove('!text-white');
        }
        menuToggleMobile.classList.remove('!bg-white');
        for (let part of mobileHbParts) {
            part.classList.remove('!bg-rooftop-blue');
        }
    }

    // closes open menus and resets nav to default state
    function closeAllNavs() {
        closeMobileNav();
        closeDesktopNav();
        closeBurgers();
    }

    function startListening() {
        window.addEventListener('click', clickListener);
        window.addEventListener('resize', resizeListener);
        window.addEventListener('scroll', scrollListener);
    }

    function stopListening() {
        window.removeEventListener('click', clickListener);
        window.removeEventListener('resize', resizeListener);
        window.removeEventListener('scroll', scrollListener);
    }


    // Debounce for resize listener to close open menus on page resize
    const closeNavResizeDebouncer = debounce(() => {
        let windowSize = window.innerWidth;
        const checkWidth = setTimeout(() => {
            if (windowSize !== window.innerWidth) {
                closeAllNavs();
                stopListening();
            }
            clearTimeout(checkWidth);
        }, 50);

    });

    // Debounce for click listener to close open menus if click is not inside menu
    const closeNavClickDebouncer = debounce((event) => {
        if (!document.getElementById('headerNavigationMenu').contains(event.target)) {
            closeAllNavs();
            stopListening();
        }
    });

    // Debounce for scroll listener to close open menus if scroll 200px or more below top of page
    const closeNavScrollDebouncer = debounce(() => {
        if (window.scrollY >= scrollLimit && (!menuBackdrop.classList.contains('opacity-0'))) {
            closeAllNavs();
            stopListening();
        }
    });

    const clickListener = () => {
        closeNavClickDebouncer(event);
    };

    const resizeListener = () => {
        closeNavResizeDebouncer();
    };

    const scrollListener = () => {
        closeNavScrollDebouncer();
    };
});
